/// <amd-module name="Dashboards/DashboardView/src/utilities/Viewport" />
import { BoundingRectangle, Viewport } from "../model/Viewport";

export function isRectanglePartiallyVisibleWithinViewport(
    boundingRect: BoundingRectangle,
    viewport: Viewport,
    omitTenPercentVisibleWidgetsFromRender: boolean
): boolean {
    let viewportBottom = viewport.bottom;
    let viewportRight = viewport.right;

    if (omitTenPercentVisibleWidgetsFromRender) {
        const tenPercentOfWidgetHeight = 0.1 * (boundingRect.bottom - boundingRect.top);
        const tenPercentOfWidgetWidth = 0.1 * (boundingRect.right - boundingRect.left);
        viewportBottom = viewportBottom - tenPercentOfWidgetHeight;
        viewportRight = viewportRight - tenPercentOfWidgetWidth;
    }

    return (
        boundingRect.left < viewportRight &&
        boundingRect.right > viewport.left &&
        (boundingRect.top < viewportBottom && boundingRect.bottom > viewport.top)
    );
}

export function isRectangleCompletelyVisibleWithinViewport(boundingRect: BoundingRectangle, viewport: Viewport): boolean {
    return (
        boundingRect.right <= viewport.right &&
        boundingRect.left >= viewport.left &&
        (boundingRect.bottom <= viewport.bottom && boundingRect.top >= viewport.top)
    );
}

export function clampRectangleInWindow(rectangle: BoundingRectangle): Viewport {
    return {
        top: Math.max(rectangle.top, 0),
        right: Math.min(rectangle.right, window.innerWidth),
        bottom: Math.min(rectangle.bottom, window.innerHeight),
        left: Math.max(rectangle.left, 0)
    };
}

/**
 * Scrolls the given element into the top-left corner of its container scrollable element
 * if it is not fully visible within the given viewport.
 */
export function scrollElementIntoViewport(element: HTMLElement, scrollableContainerElement: HTMLElement, viewport: Viewport) {
    const elementRectangle = element.getBoundingClientRect();
    if (!isRectangleCompletelyVisibleWithinViewport(elementRectangle, viewport)) {
        // IE/Edge don't support scrollBy
        if (typeof scrollableContainerElement.scrollBy !== "function") {
            scrollableContainerElement.scrollTop += elementRectangle.top - viewport.top;
            scrollableContainerElement.scrollLeft += elementRectangle.left - viewport.left;
        } else {
            scrollableContainerElement.scrollBy({
                top: elementRectangle.top - viewport.top,
                left: elementRectangle.left - viewport.left,
                behavior: "smooth"
            });
        }
    }
}
